import { Icon } from '@eventbrite/eds-icon';
import {
    ChevronDownChunky,
    ChevronUpChunky,
} from '@eventbrite/eds-iconography';
import React from 'react';
import { v4 as UUID } from 'uuid';
import { NestedDropdownItemProps } from '../../../../types';
import { SecondaryDropdown } from '../SecondaryDropdown';
import { SimpleDropdownItem } from '../SimpleDropdownItem';
import styles from './NestedDropdownItem.module.scss';

const NestedDropdownItem = ({
    iconType,
    text,
    dropdownItems,
}: NestedDropdownItemProps) => {
    return (
        <li className={styles.nestedDropdownTrigger} tabIndex={-1}>
            <span className={styles.titleContainer} tabIndex={0}>
                {iconType ? (
                    <span className={styles.iconContainer}>
                        <Icon type={iconType} />
                    </span>
                ) : null}
                <span>{text}</span>
                <span className={styles.arrowIcons}>
                    <Icon type={<ChevronUpChunky />} />
                    <Icon type={<ChevronDownChunky />} />
                </span>
            </span>

            <ul className={styles.submenu} aria-label="submenu">
                {dropdownItems?.map((props) => {
                    return props.dropdownItems ? (
                        <SecondaryDropdown key={UUID()} {...props} />
                    ) : (
                        <SimpleDropdownItem {...props} key={UUID()} />
                    );
                })}
            </ul>
        </li>
    );
};

export default NestedDropdownItem;
